export const GroupSelectCount = 50;
export const RowId = 'SettingsRow';
export const startEndSettingUseFieldName = 'rows';
export const SmartSuggestionSettingUseFieldName = 'smartSuggestionRows';

export enum EnabledDisabled {
  enabled = 'enabled',
  disabled = 'disabled'
}
export enum SettingsType {
  START_END_TIME = 'setting-type-start-end-time',
  SMART_SUGGESTION = 'setting-type-smart-suggestion'
}
